import { useState, useRef } from 'react';

import {useMutation, useQueryClient } from '@tanstack/react-query';

import authAxios from '../../components/authAxios';
import { TextField } from "@mui/material";

import { Modal, message } from 'antd';
import NumberFormat from "react-number-format";

import UserAlerts from '../../components/UserAlerts';


const MeterEdit = ({isModalOpen, setIsModalOpen, meter }) => {
    const queryClient = useQueryClient();

    const errorRef = useRef(null);
    const validDataRef = useRef(false);
    const [error, setError] = useState('');

    const [reference, setReference] = useState(meter.reference);
    const [meterPrice, setMeterPrice] = useState(meter.price);

    const handleCancel = () => {
        setIsModalOpen(false);
    };
   
    const mutation = useMutation({
        mutationFn: (meterData) => {
            return authAxios.patch(`/rentals/meters/${meter.id}/`, meterData);
        },
        onError: (error, variables, context) => {
            console.log("ERROR",error)

            if (error.response.data.error){
                // If it's an array, display each error message
                if (Array.isArray(error.response.data.error)) {
                    error.response.data.error.map((errorMessage) => (
                        setError(errorMessage)
                    ));
                } else {
                    // Handle single error message
                    setError(error.response.data.error); 
                }
            } else {
                // Fallback to Standard error message
                setError(error.message); 
            }      
        },
        onSuccess: (result) => {
            console.log("RESULT", result)
            message.success(`Successfully updated meter ${result.data.reference}`);
            queryClient.invalidateQueries(['meters']);
            setIsModalOpen(false);
        },
        })


    const handleSubmit = (e) => {
        e.preventDefault();
        validDataRef.current=true

        if (validDataRef.current===true) {
            const price = parseFloat(meterPrice.replace(/,/g, ''));
            const meterData = {reference, price };

            console.log("METER", meterData)
            mutation.mutate(meterData)
        }
    };


    return (
        <>
        {isModalOpen && 
            <Modal className="dashboard-modal" title="Edit Utility Meter" visible={isModalOpen} open={isModalOpen} onOk={handleSubmit} onCancel={handleCancel}>
                <div className="dashboard-form">

                    <div ref={errorRef}>
                        <UserAlerts error={error}  />
                    </div>

                    <form onSubmit={handleSubmit}>

                        <TextField className="custom-input"
                            label="Property" 
                            variant="outlined" 
                            fullWidth
                            disabled
                            value={meter.property_unit_name}
                        />

                        <TextField className="custom-input"
                            label="Product" 
                            variant="outlined" 
                            fullWidth
                            disabled
                            value={meter.sku_name}
                        />

                        <TextField className="custom-input"
                            value={reference}
                            onChange={(e) => {
                                setReference(e.target.value)
                            }}
                            label="Meter No" 
                            variant="outlined" 
                            fullWidth
                            required
                        />
                        
                        <NumberFormat 
                            onChange={(e) => {
                                setMeterPrice(e.target.value)
                            }}
                            className="custom-input"
                            fullWidth
                            label="Price" 
                            variant="outlined" 
                            customInput={TextField}
                            thousandSeparator={true} 
                            value={meterPrice}
                        />

                    </form>
                </div>
            </Modal>
        }
        </>

    );
};

export default MeterEdit;
